import { useState } from "react";
import { Link } from "react-router-dom";
import {
  Stack,
  Container,
  Button,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { Text } from "./Text";
import { HashLink } from "react-router-hash-link";

export const Nav = () => {
  const [modal, setModal] = useState<boolean>(true);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Stack>
      {isMobile ? null : (
        <Container
          sx={{
            paddingTop: 1.7,
            paddingBottom: 1.7,
          }}
        >
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="center"
            flexWrap="wrap"
            gap="20px 95px"
          >
            <Stack width={279}>
              <Link to="/">
                <img
                  src="/images/nav-logo.png"
                  alt=""
                  style={{
                    width: "100%",
                  }}
                />
              </Link>
            </Stack>
            <Stack direction="row" gap={4} alignItems="center">
              <Stack minWidth={100}>
                <Link to="/fungi">
                  <Text color="primary" fontWeight={500} lineHeight="29px">
                    About Fungi
                  </Text>
                </Link>
              </Stack>
              <Stack
                position="relative"
                direction="row"
                minWidth={120}
                gap={1.4}
                height="100%"
                onClick={() => setModal(!modal)}
                sx={{
                  cursor: "pointer",
                  "&:hover": {
                    "& .menuModal": {
                      opacity: 1,
                      display: "block",
                    },
                  },
                }}
              >
                <HashLink to="/technology">
                  <Text color="primary" fontWeight={500} lineHeight="29px">
                    Technology
                  </Text>
                </HashLink>
                <KeyboardArrowDownIcon
                  color="primary"
                  fontSize="small"
                  sx={{
                    paddingTop: 0.7,
                  }}
                />
                <Stack
                  width={350}
                  textAlign="center"
                  padding={2.7}
                  borderRadius="14px"
                  className="menuModal"
                  sx={{
                    display: "none",
                    background: "#f6f6f6",
                    boxShadow: "0px 0px 8px 2px rgba(221, 221, 221, 0.4)",
                    opacity: 0,
                    position: "absolute",
                    bottom: "-2px",
                    left: "50%",
                    transform: "translate(-50%,100%)",
                    zIndex: 10,
                    "& p": {
                      position: "relative",
                      "&:before": {
                        content: "''",
                        display: "block",
                        width: "100%",
                        height: "2px",
                        background: "#ffbd00",
                        position: "absolute",
                        bottom: 0,
                        opacity: 0,
                      },
                    },
                    "& p:hover": {
                      color: "#006400",
                      "&:before": {
                        opacity: 1,
                      },
                    },
                  }}
                >
                  <HashLink to="/technology#1">
                    <Text lineHeight={2.4} color="#000">
                      細胞内で自律的に複製可能なベクター
                    </Text>
                  </HashLink>
                  <HashLink to="/technology#2">
                    <Text lineHeight={2.4} color="#000">
                      純国産のCRISPRフリーゲノム編集ツール
                    </Text>
                  </HashLink>
                  <HashLink to="/technology#3">
                    <Text lineHeight={2.4} color="#000">
                      微生物特化型のゲノム編集手法
                    </Text>
                  </HashLink>
                  <HashLink to="/technology#4">
                    <Text lineHeight={2.4} color="#000">
                      無性的なゲノム交雑の促進
                    </Text>
                  </HashLink>
                </Stack>
              </Stack>
              <Stack minWidth={100}>
                <Link to="/service">
                  <Text color="primary" fontWeight={500} lineHeight="29px">
                    Services
                  </Text>
                </Link>
              </Stack>
              <Stack minWidth={100}>
                <Link to="/company">
                  <Text color="primary" fontWeight={500} lineHeight="29px">
                    Company
                  </Text>
                </Link>
              </Stack>
              <Stack minWidth={182}>
                <Link to="/contact">
                  <Text color="primary" fontWeight={500}>
                    <Button variant="contained">Contact Us</Button>
                  </Text>
                </Link>
              </Stack>
            </Stack>
          </Stack>
        </Container>
      )}
    </Stack>
  );
};
